import { useState } from 'react';
// configs
import { EX4380, EX6002 } from 'config/flags';
// apis
import { uploadFileToDesactivated } from 'api';

export const useProvider = () => {
    // states
    const [showLoadingScreen, setShowLoadingScreen] = useState<boolean>(false);
    const [isFetching, setIsFetching] = useState<boolean>(false);
    const [blockerFormat, setBlockerFormat] = useState(false);
    const [formatFile, setFormatFile] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [downloadErrorLink, setDownloadErrorLink] = useState<string | null>(null);

    const resetStore = () => {
        setIsFetching(false);
        setBlockerFormat(false);
        setError(null);
        setDownloadErrorLink(null);
    };

    const handlerDrop = (e) => {
        e.preventDefault();

        const files = e.dataTransfer.files;

        for (let i = 0; i < files.length; i++) {
            const format = files[i].name.split('.').pop();

            if (
                format !== 'txt' ||
                format !== 'xls' ||
                format !== 'xlsx' ||
                format !== 'res' ||
                format !== 'fal_' ||
                format !== 'fal'
            ) {
                setBlockerFormat(true);
                setError(null);
                setIsFetching(!isFetching);
                return;
            }
            setFormatFile(files[i].name);
            setBlockerFormat(false);

            return;
        }
    };

    const handleValidation = (file: any): boolean => {
        const maxSizeInBytes = 1024 * 1024;

        const format = file.type.split('/')[1];
        const fileType =
            file.name.split('.')[1] === 'res' ||
            file.name.split('.')[1] === 'fal_' ||
            file.name.split('.')[1] === 'fal' ||
            file.name.split('.')[1] === 'csv';

        if (EX6002) {
            if (file.size > maxSizeInBytes) {
                setBlockerFormat(true);
                return false;
            }
            setFormatFile(file.name);
            setBlockerFormat(false);
            return true;
        } else {
            if (
                !!EX4380 &&
                format !== 'plain' &&
                format !== 'vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
                format !== 'vnd.ms-excel' &&
                !fileType
            ) {
                setBlockerFormat(true);
                return false;
            }
            if (!EX4380 && format !== 'plain' && !fileType) {
                setBlockerFormat(true);
                return false;
            }
            if (file.size > maxSizeInBytes) {
                setBlockerFormat(true);
                return false;
            }
            setFormatFile(file.name);
            setBlockerFormat(false);
            return true;
        }
    };

    const handleUpload = (file) => {
        if (handleValidation(file)) {
            setIsFetching(true);
            uploadFileToDesactivated(file)
                .then((response) => {
                    if (response?.data?.success) {
                        // esta todo ok (salta modal)
                        resetStore();
                    } else {
                        setError(response?.data?.message);
                        if (response?.data?.message !== 'file_is_empty') {
                            setDownloadErrorLink(response?.data?.file_with_error);
                        }
                    }
                })
                .catch((e) => console.error(e))
                .finally(() => setIsFetching(false));
            setBlockerFormat(false);
            return;
        }
    };

    return {
        showLoadingScreen,
        setShowLoadingScreen,
        handleUpload,
        isFetching,
        setIsFetching,
        handlerDrop,
        blockerFormat,
        setBlockerFormat,
        resetStore,
        formatFile,
        error,
        setError,
        downloadErrorLink,
    };
};
